"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isJobInProgress = isJobInProgress;

var _consts = require("./consts");

function isJobInProgress(job) {
  return job.status.code === _consts.IA_JOB_STATUS.QUEUED || job.status.code === _consts.IA_JOB_STATUS.ACTIVE || job.status.code === _consts.IA_JOB_STATUS.STARTING || job.status.code === _consts.IA_JOB_STATUS.CANCEL_REQUESTED; // Just because cancel was requested, doesn't mean the job stops.
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/jobs/util.js
// module id = 94
// module chunks = 0